import { createUseMutationHook } from './createUseMutationHook';

export const usePersonTravelPolicyPut = createUseMutationHook(
    'edit_person_group_or_travel_policy',
    () => ['get_person_travel_policy', 'get_person_details'],
);
